import { render, staticRenderFns } from "./ProductShijiazhuang.vue?vue&type=template&id=91679b80&scoped=true&lang=pug"
import script from "./ProductShijiazhuang.vue?vue&type=script&lang=js"
export * from "./ProductShijiazhuang.vue?vue&type=script&lang=js"
import style0 from "./ProductShijiazhuang.vue?vue&type=style&index=0&id=91679b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91679b80",
  null
  
)

export default component.exports